if(!customElements.get('custom-newsletter') || !customElements.get('custom-newsletter-popup') || !customElements.get('custom-password-newsletter')){
    class CustomNewsletter extends HTMLElement {
        constructor(){
            super();
    
            this.btnSubmit = this.querySelector('button[type="submit"]');
            this.form = this.querySelector('#form-newsletter');
            if(this.form){
                this.formInner = this.form.querySelector('.newsletter__form-inner');
                this.inputEmail = this.querySelector('input[type="email"]');
                this.form.addEventListener('submit', this.submitForm.bind(this));

                this.inputEmail.addEventListener('focus', (e) => {
                    if(e.inputType !== 'mouse'){
                        this.form.classList.add('keyboard-focused');
                    }
                });
                this.inputEmail.addEventListener('blur', () => {
                    this.form.classList.remove('keyboard-focused');
                });
                this.inputEmail.addEventListener('mousedown', () => {
                    this.form.classList.remove('keyboard-focused');
                });
            }
            
            this.errorMessage = this.querySelector('.input-error');
        }
    
        submitForm(e){
            if(window.Shopify.recaptchaV3) return;
            if(this.btnSubmit.getAttribute('disabled') == 'true') return;
            
            this.btnSubmit.setAttribute('disabled', 'true');
        }

        displayEmailInvalidMessage(){
            if(!this.inputEmail) return;

            this.errorMessage.innerHTML = (this.validateEmail(this.inputEmail.value))? "Email already exist" : "Invalid email";
        }

        validateEmail(email){
            var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(email);
        }
    }
    
    if(document.querySelector('custom-password-newsletter')){
        customElements.define('custom-password-newsletter', CustomNewsletter);
    }else{
        customElements.define('custom-newsletter', CustomNewsletter);
    }

    class CustomNewsletterPopup extends CustomNewsletter {
        constructor(){
            super();
    
            if(window.location.pathname == '/challenge'){
            }else if(this.dataset.editMode == 'true'){
                this.delay = 10;
                this.init();
            }else if(sessionStorage.getItem('newsletter-popup-open') != 'true'){
                // only display once per session
                this.init();
            }
        }
        
        init(){
            this.delay = this.delay? this.delay : this.dataset.delay * 1000;
            this.closed = getCookie('newsletter-closed');
            this.subscribed = getCookie('newsletter-subscribed');
            this.form = this.querySelector('#form-newsletter');
    
            this.querySelectorAll('[data-type="close"]').forEach(item => {
                item.addEventListener('click', () => {
                    this.close();
                })
            })
    
            this.addEventListener('keyup', e => {
                if(e.code?.toUpperCase() === 'ESCAPE') this.close();
            })
            this.addEventListener('click', e => {
                if(e.target === this) this.close();
            })
    
            this.form.addEventListener('submit', this.submitForm.bind(this));

            setTimeout(() => {
                if(this.closed !== null || this.subscribed !== null) return;
                this.open();
            }, this.delay);
        }
    
        open(){
            this.previouslyFocusedElement = document.activeElement;
            this.setAttribute('data-hidden', 'false');
            sessionStorage.setItem('newsletter-popup-open', 'true');
    
            // body not to be scrollable
            document.querySelector('html').style.overflow = 'hidden';
            
            this.addFocus();
        }

        addFocus(){
            if(this.form){
                setTimeout(() => {
                    this.form.querySelector('.input-email').focus();
                }, 100);
            }
        }
    
        close(){
            setCookie('newsletter-closed', 'true');
            this.setAttribute('data-hidden', 'true');
    
            // body not to be scrollable
            document.querySelector('html').style.overflow = 'initial';

            if(this.previouslyFocusedElement){
                this.previouslyFocusedElement.focus();
            }
        }
    
        submitForm(e){
            super.submitForm(e);
        }
    }
    
    customElements.define('custom-newsletter-popup', CustomNewsletterPopup);    
}

if(!customElements.get('newsletter-invalid')){
    class NewsletterInvalidMessage extends HTMLElement {
        constructor(){
            super();

            this.init();
        }

        init(){
            this.email = this.dataset.email.trim();
            this.emailExists = this.querySelector('.email-exists');
            this.invalidEmail = this.querySelector('.invalid-email');

            if(this.validateEmail(this.email)){
                this.emailExists.setAttribute('aria-hidden', 'false');
            }else{
                this.invalidEmail.setAttribute('aria-hidden', 'false');
            }
        }

        validateEmail(email){
            var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(email);
        }
    }

    customElements.define('newsletter-invalid', NewsletterInvalidMessage);
}